import { writable, derived, type Writable } from 'svelte/store';

export const footerPath: Writable<string> = writable('');
